import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import CommonModal from "../modal/CommonModal";
import Icons from "../iconMaster/Icons";
import { Link } from "react-router-dom";

const ConfirmationPoup = ({
    showConfirmation,
    setShowConfirmation,
    packageName
}: any) => {
    return (
        <>
            {/* <Modal
                isOpen={showConfirmation}
                className="modal-lg"
                centered
            >
                <ModalHeader toggle={() => { setShowConfirmation(false); }} >Confirmation</ModalHeader>
                <ModalBody>
                    <p>Thanks for choosing Genius World. </p>
                    <p>The expert team of Genius World Tours will get back to you shortly to answer all your questions. We will be happy to assist you!</p>
                </ModalBody>
                <ModalFooter>
                    <button className="btn btn-primary"
                        onClick={(e: any) => { e.preventDefault(); setShowConfirmation(false) }}>Ok</button>
                </ModalFooter>
            </Modal> */}

            <CommonModal
                show={showConfirmation}
                onHide={() => setShowConfirmation(false)}
                size="md"
                showFooter={false}
                contentClassName="custom-modal ar_popup_bg bg-light inter-regular text-center"
                showHeader={false}
            >
                <button
                    type="button"
                    className="btn-close custom-btn"
                    onClick={(e) => {
                        e.preventDefault();
                        setShowConfirmation(false);
                    }}
                ></button>
                <Icons name="confirmation-icon" width="79" height="79" />
                <h1 className="fs-3 fw-bolder mt-3" style={{ color: "#49963F" }}>Thank You for Your Inquiry!</h1>
                <h4 className="fs-5 fw-bold fst-italic">We’ve received your {packageName && <strong>{packageName}</strong>} enquiry.</h4>
                <p>Our travel experts are reviewing it and will contact you shortly to help plan your perfect journey.</p>
                <Link className="animated-btn btn btn-shadow m-auto px-5 rounded-5" to="/">Back to Home</Link>

            </CommonModal>
        </>
    )
}
export default ConfirmationPoup;